module.exports = __webpack_public_path__ + "static/media/57.fff46a23.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/57.svg
// module id = 183
// module chunks = 0